import BASE_URL from '@naruto/bgdcms/src/base/url';
import ADMIN_PAGE_KEY from '@naruto/bgdcms/src/base/routes/AdminPageKey';
import { Routes } from '@naruto/bgdcms/src/base/routes/types';
import ServiceRoutes from '@naruto/bgdcms/src/base/routes/Service';
import ProjectRoutes from '@naruto/bgdcms/src/base/routes/Project';
import UserRoutes from './Account';

const ADMIN_URL = BASE_URL.ADMIN;

const Admin: Routes = {
  main: [
    {
      id: ADMIN_PAGE_KEY.HOME,
      route: `${ADMIN_URL.ROOT_PAGE_HOME}`,
      component: import('@naruto/bgdcms/src/components/Pages/Home'),
      exact: true,
      showInSidebar: true,
      root: true,
      subRoute: [],
      lang: 'frontend.global.route.home',
      icon: 'route/disactive/home.svg',
      iconActive: 'route/active/home.svg'
    },
    {
      id: ADMIN_PAGE_KEY.SERVICE,
      route: `${ADMIN_URL.ROOT_PAGE_SERVICE}`,
      component: import('@naruto/bgdcms/src/components/Pages/Service'),
      exact: false,
      showInSidebar: true,
      subRoute: [...ServiceRoutes.main],
      lang: 'frontend.global.route.service',
      icon: 'route/disactive/service.svg',
      iconActive: 'route/active/service.svg'
    },
    {
      id: ADMIN_PAGE_KEY.PROJECT,
      route: `${ADMIN_URL.ROOT_PAGE_PROJECT}`,
      component: import('@naruto/bgdcms/src/components/Pages/Project'),
      exact: false,
      showInSidebar: true,
      subRoute: [...ProjectRoutes.main],
      lang: 'frontend.global.route.project',
      icon: 'route/disactive/project.svg',
      iconActive: 'route/active/project.svg'
    },
    {
      id: ADMIN_PAGE_KEY.CONTACT,
      route: `${ADMIN_URL.ROOT_PAGE_CONTACT}`,
      component: import('@naruto/bgdcms/src/components/Pages/Contact'),
      exact: true,
      showInSidebar: true,
      subRoute: [],
      lang: 'frontend.global.route.contact',
      icon: 'route/disactive/contact.svg',
      iconActive: 'route/active/contact.svg'
    },
    {
      id: ADMIN_PAGE_KEY.ACCOUNT,
      route: `${ADMIN_URL.ROOT_PAGE_ACCOUNT}`,
      component: import('@naruto/bgdcms/src/components/Pages/Account'),
      exact: false,
      showInSidebar: true,
      subRoute: [...UserRoutes.main],
      lang: 'frontend.global.route.user',
      icon: 'route/disactive/user.svg',
      iconActive: 'route/active/user.svg'
    }
  ]
};

export default Admin;
